module.exports = {
      id: "textsms-usage",
      viewBox: "0 0 28.57 28.57",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#textsms",
      toString: function () {
        return this.url;
      }
    }